var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"test-portal",staticStyle:{"padding-top":"30vh","background-color":"bisque"}})
}
var staticRenderFns = []

export { render, staticRenderFns }